<template>
    <div
        :class="['listener-mini-player', hasTrack ? '' : 'is-idle']"
        @click="openNowPlaying"
    >
        <div class="listener-mini-player__cover">
            <img
                :src="coverImage"
                :alt="displayTitle"
                class="listener-mini-player__cover-image"
            >
        </div>
        <div class="listener-mini-player__meta">
            <div class="listener-mini-player__title">{{ displayTitle }}</div>
            <div class="listener-mini-player__artist">{{ displayArtist }}</div>
        </div>
        <button
            type="button"
            class="listener-mini-player__button"
            :disabled="!hasTrack"
            @click.stop="togglePlay"
        >
            <svg v-if="!isPlaying" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z" />
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 5h3v14H7zm7 0h3v14h-3z" />
            </svg>
        </button>
        <button
            type="button"
            class="listener-mini-player__button listener-mini-player__button--ghost"
            :disabled="!hasTrack"
            @click.stop="nextTrack"
        >
            <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 6.7v10.6a1 1 0 0 0 1.53.85L16 12.85a1 1 0 0 0 0-1.7L7.53 5.85A1 1 0 0 0 6 6.7zm11-.2h2v11h-2z" />
            </svg>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ListenerMiniPlayer',
    computed: {
        ...mapGetters(['track']),
        hasTrack() {
            return !!this.track
        },
        isPlaying() {
            return this.$store.state.common.isPlaying
        },
        streamTitle() {
            return this.$store.state.common.streamTitle
        },
        coverImage() {
            return this.track && this.track.image
                ? this.track.image
                : '/static/dist/img/album_null.jpg'
        },
        displayTitle() {
            if (!this.track) {
                return this.$tt('暂无播放内容')
            }
            return this.streamTitle || this.track.title
        },
        displayArtist() {
            if (!this.track) {
                return this.$tt('选择一首歌开始播放')
            }
            return this.track.artist || this.track.album || this.$tt('未知艺术家')
        }
    },
    methods: {
        togglePlay() {
            if (!this.track) return
            this.$store.dispatch('playPause')
        },
        nextTrack() {
            if (!this.track) return
            this.$store.dispatch('next')
        },
        openNowPlaying() {
            if (!this.track) return
            this.$router.push({ name: 'playingList', params: { id: this.track.id } })
        }
    }
}
</script>

<style scoped>
.listener-mini-player {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 0.75rem 0.95rem;
    border-radius: 1.6rem;
    background:
        linear-gradient(135deg, rgba(18, 18, 18, 0.96), rgba(42, 42, 42, 0.92));
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);
    color: #fff;
}

.listener-mini-player.is-idle {
    opacity: 0.94;
}

.listener-mini-player__cover {
    width: 3.15rem;
    height: 3.15rem;
    border-radius: 1rem;
    overflow: hidden;
    flex-shrink: 0;
}

.listener-mini-player__cover-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.listener-mini-player__meta {
    min-width: 0;
    flex: 1;
}

.listener-mini-player__title,
.listener-mini-player__artist {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.listener-mini-player__title {
    font-size: 0.95rem;
    font-weight: 700;
}

.listener-mini-player__artist {
    margin-top: 0.18rem;
    font-size: 0.76rem;
    color: rgba(255, 255, 255, 0.68);
}

.listener-mini-player__button {
    width: 2.85rem;
    height: 2.85rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #111827;
    flex-shrink: 0;
}

.listener-mini-player__button svg {
    width: 1.3rem;
    height: 1.3rem;
}

.listener-mini-player__button:disabled {
    cursor: default;
    opacity: 0.55;
}

.listener-mini-player__button--ghost {
    width: 2.25rem;
    height: 2.25rem;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
}
</style>
